import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import Landing from "@/pages/Landing";

const PolicyPage = lazy(() => import("@/pages/PolicyPage"));
const ThankYou = lazy(() => import("@/pages/ThankYou"));
const TrackingTest = lazy(() => import("@/pages/TrackingTest"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const Admin = lazy(() => import("@/pages/Admin"));

export default function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <Suspense fallback={<div className="min-h-screen bg-bone" />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/diabetes-pro" element={<Landing />} />
            <Route path="/policy/:slug" element={<PolicyPage />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/tracking-test" element={<TrackingTest />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </Suspense>
        <Toaster position="top-center" richColors />
      </SiteProvider>
    </BrowserRouter>
  );
}
